import axios from "axios";
import { API_BASE_URL } from "../environment";
import { errorAlert } from "../style/scss/utils/Alerts";

export const authLogin = async (data) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/user/login`, data);
    return res.data;
  } catch (error) {
    errorAlert("Info", `${error.response.data.message}`);
  }
};

export const customerLogin = async (data) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/user/customer-login`, data);
    return res.data;
  } catch (error) {
    errorAlert("Info", `${error.response.data.message}`);
  }
};

export const uploadFile = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/files`, data);
  return res.data;
};
export const ChangeStatus = async (id, data,) => {
  const res = await axios.patch(`${API_BASE_URL}/common?table=user&id=${id}`, data);
  return res.data;
};

export const assignManager = async (id, data) => {
  const res = await axios.patch(`${API_BASE_URL}/common?table=retailer&id=${id}`, data);
  return res.data;
};
export const getProfileData = async () => {
  try {
    const id = JSON.parse(sessionStorage.getItem("info"));
    const natId = id.user_id;
    const res = await axios.get(`${API_BASE_URL}/filter/profiledata?user_id=${natId}`);
    return res.data;
  } catch (error) {
    console.error(error, "Error");
  }
};
export const getDashboardData = async (data) => {
  const id = JSON.parse(sessionStorage.getItem("info"));
  const natId = id.user_id;
  try {
    const res = await axios.get(`${API_BASE_URL}/dashboard?user_id=${natId}&start_date=${data?.start_date}&end_date=${data?.end_date}`);
    return res.data;
  } catch (error) {
    console.error(error, "error");
  }
};

export const OtpSend = async (data) => {
  const sessionInfo = JSON.parse(sessionStorage.getItem("info") || "{}");
  const payload = {
    ...data,
    user_id: data?.user_id || sessionInfo.user_id || sessionInfo.id,
    user_type: data?.user_type || sessionInfo.type,
    user_name: data?.user_name || sessionInfo.username,
    company_id:
      data?.company_id ||
      (sessionInfo.type === "financer" ? sessionInfo.id : undefined),
  };
  const res = await axios.post(`${API_BASE_URL}/auth/otp_send`, payload);
  return res.data;
};
export const verifyAadharOtp = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/auth/verifiy_aadhar`, data);
  return res.data;
};
export const getBookData = async (data) => {
  const res = await axios.get(`${API_BASE_URL}/expenses/cashbank?user_id=${data.user_id}&cash_bank=${data.cash_bank}`);
  return res.data;
};

export const getAllLoanStatus = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/loans/loanStatus`, data);
  return res.data;
};

export const getUserPlanDetails = async () => {
  const id = JSON.parse(sessionStorage.getItem("info"));
  const natId = id?.id;
  const res = await axios.get(`${API_BASE_URL}/financer/data-by-id/${natId}`);
  return res.data;
};
